var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"text-gray mb-2"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('messages.app.ui.listen_question'))+" ")])]),(_vm.question.isAudio)?_c('Player',{ref:"player",attrs:{"class-type":"primary","disabled":_vm.isNavigationDisabled,"media":_vm.question.media}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }